/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */
import React, { useEffect, useState, Fragment } from "react";
import { SimpliCitySDK } from "cms/sdk";
import { useAuth } from "cms/auth/hooks/useAuth";
import { objectHasPropertyString } from "cms/utils/empty-exists";
import { Logger } from "cms/utils/logger";

const LANGLEY_DEFAULT_NEWS_IMAGE_GUID = "d9b66c67-9ce0-4c6b-9e91-ab7c37fbd302";

const NewsItemImage = (props) => {
    const model = props?.model;
    const { token } = useAuth();
    const [image, setImage] = useState();
    const url = image?.url;
    const alt = image?.alt;

    const image_style = {
        backgroundImage: `url(${url})`,
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
    };

    useEffect(() => {
        const fetchImage = async (_model) => {
            let guid = _model?.banner_image?.image;
            // Use default image if no banner image present
            if (!guid) {
                guid = LANGLEY_DEFAULT_NEWS_IMAGE_GUID;
            }
            if (guid && image?.guid !== guid) {
                const current_image = await SimpliCitySDK.images.findOne(token, guid);
                if (current_image && current_image.guid) {
                    setImage(current_image);
                } else {
                    Logger.warn("Could not load image...", guid);
                }
            }
        };
        fetchImage(model);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [model]);

    return (
        <Fragment>
            {objectHasPropertyString(image, "url") && (
                <>
                    <div className={`news-item-image`} style={image_style} title={alt} />
                </>
            )}
        </Fragment>
    );
};

export { NewsItemImage };
